<!--
  Nuxt 应用根组件。
  这里只负责挂载布局和当前页面，是所有页面渲染的最外层入口。
-->
<template>
  <!-- NuxtLayout：启用布局系统，NuxtPage：渲染页面内容 -->
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
// 全局初始化逻辑（可选）
onMounted(() => {
  // console.log('🚀 AgentDesk initialized')
  console.log('🚀 v1.9')
})
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

#app {
  height: 100%;
}
</style>
